var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"fullpage"}},[_c('banner'),_c('features'),_c('about'),_c('portfolio'),_c('contact'),_c('footer-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }